/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddPayor/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AddPayor({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/AddAction/AddPayor"
  
}) {
let paymentPlanPayorsValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'payors',
format: fromFormat.listLength,
})
let constantData = 2
let aggregateData = fromAggregate.equals(paymentPlanPayorsValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 width="100%"
 type="ghost"
 onClick={onClick}
 data="payment_plan.payors"
 format="/Data/format.js listLength"
 data={2}
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Payor"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}